// Desktop menu open in hover 

// document.querySelectorAll('.mega-menu').forEach(menu => {
//   const content = menu.querySelector('.mega-menu__content');
//   const summary = menu.querySelector('summary');

//   summary.addEventListener('mouseenter', () => {
//     document.querySelectorAll('.mega-menu[open]').forEach(openMenu => {
//       if (openMenu !== menu) openMenu.removeAttribute('open');
//     });
//     menu.setAttribute('open', true);
//   });

//   // keep open while hovering content
//   content.addEventListener('mouseenter', () => {
//     menu.setAttribute('open', true);
//   });

//   // close when leaving summary or content
//   menu.addEventListener('mouseleave', () => {
//     menu.removeAttribute('open');
//   });
// });


document.querySelectorAll('.mega-menu').forEach(menu => {
  const content = menu.querySelector('.mega-menu__content');
  const summary = menu.querySelector('summary');
  let openTimer = null;
  let closeTimer = null;

  const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
  };

  const openMenu = () => {
    clearTimeout(closeTimer);
    menu.setAttribute('open', true);

    const scrollBarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = scrollBarWidth + 'px'; // add padding to avoid shift
    }
  };

  const closeMenu = () => {
    clearTimeout(openTimer);
    menu.removeAttribute('open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = ''; // restore padding
  };

  summary.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
    openTimer = setTimeout(() => {
      document.querySelectorAll('.mega-menu[open]').forEach(openMenu => {
        if (openMenu !== menu) openMenu.removeAttribute('open');
      });
      menu.setAttribute('open', true);

      const scrollBarWidth = getScrollbarWidth();
      document.body.style.overflow = 'hidden';
      if (scrollBarWidth > 0) {
        document.body.style.paddingRight = scrollBarWidth + 'px';
      }
    });
  });

  content.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
    const scrollBarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = scrollBarWidth + 'px';
    }
  });

  menu.addEventListener('mouseleave', () => {
    clearTimeout(openTimer);
    closeTimer = setTimeout(() => {
      menu.removeAttribute('open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    });
  });
});
